<script lang="ts">
	import ReviewCard from "@components/ReviewCard.svelte";
	import Slideshow from "@components/common/Slideshow.svelte";
	import type { ClassValue } from "svelte/elements";
	import type { Review } from "@core/schema/Review.js";

	const { class: customClass, reviews }: { class?: ClassValue; reviews: Review[] } = $props();
</script>

{#if reviews.length > 0}
	<Slideshow
		class={[customClass, "gap-2 py-8 md:py-16 lg:py-20 pl-2 full-width"]}
		flowDirection="right"
		speed={1}
		forceSlidingOnMobile
	>
		{#each reviews as review (review.id)}
			<ReviewCard {review} />
		{/each}
	</Slideshow>
{/if}
